export default class State {
    state: Object;

    constructor () {
        this.state = {};
    }

    get value() {
        return this.getPureObject(this.state);
    }

    set value (value: Object) {
        let pureValueObject = this.getPureObject(value);
        this.state = Object.assign(this.state, pureValueObject);
    }

    resetState (state: Object) {
        this.state = this.getPureObject(state);
    }

    getPureObject (value: Object) {
        return JSON.parse(JSON.stringify(value));
    }

    isEqual(state1: Object) {
        return JSON.stringify(state1) == JSON.stringify(this.value);
    }
}


// WEBPACK FOOTER //
// ./src/Models/State.ts